"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const runtimePlugin = () => {
    return {
        name: 'initExoRuntimePluginTemplate',
        beforeRequest: async (args) => {
            // START - INJECT USER IMPORT SCRIPT
await import("/mnt/data/jenkins/workspace/_BIM360_acs-exo-skeleton_PR-1987/src/initialize-runtime.ts")
            // END - INJECT USER IMPORT SCRIPT
            return args;
        },
    };
};
exports.default = runtimePlugin;
//# sourceMappingURL=initExoRuntimePluginTemplate.js.map